import { LOAD_STATE } from '../constants/loads'
import { ICustomerContact } from './customers'

export enum SharedType {
  email = 'email',
  sms = 'sms',
}

export interface ActivityMetadata {
  status?: LOAD_STATE
}

export interface IActivityMetadataShared extends ActivityMetadata {
  sharedVia: SharedType[]
  sharedWithDriverName: string
}

export interface IActivityMetadataCheckOutTimeUpdated extends ActivityMetadata {
  stop: {
    id: string
    checkedOutAt?: string
  }
}

export interface IActivityMetadataCheckInTimeUpdated extends ActivityMetadata {
  stop: {
    id: string
    checkedInAt?: string
  }
}

export interface IActivityMetadataShipmentCreated extends ActivityMetadata {}

export interface IActivityMetadataShipmentImported extends ActivityMetadata {
  source: string
}

export interface IActivityMetadataStatusUpdated extends ActivityMetadata {
  currentStopSequence: number | undefined
  status: LOAD_STATE
  stop?: {
    id: string
    checkedInAt?: string
    checkedOutAt?: string
  }
  subscribers?: ICustomerContact[]
}
